import Link from "@components/Link";
import Button from "@components/Button";
import Icons from "@gstyles/styleguide/icons";
import useSwiper from "@hooks/useSwiper";
import { useTranslationContext } from "@providers/TranslationProvider";
import cx from "classnames";
import { useState } from "react";
import Item from "./Item";
import styles from "./VisitOurRooms.module.scss";
import ClipText from "@components/ClipText/ClipText";
import { EffectFade } from "swiper";
import "swiper/css/effect-fade";
import { useRouteContext } from "@providers/RouteProvider";
import { useBookingContext } from "@providers/BookingProvider";
import { usePageContext } from "@providers/PageProvider";
import renderPropsComposer from "@utils/renderPropsComposer";
import helper from "@utils/helper";
import _ from "lodash";
export default function VisitOurRooms() {
  const { i18n } = useTranslationContext();
  const { pageData, hotel } = usePageContext();
  const {
    title,
    readMoreButton,
    rooms: roomsData,
  } = helper.formatVisitRoomData(pageData);
  const [roomSelected, setRoomSelected] = useState(_.get(roomsData, "0.slug"));
  const swiperRooms = useSwiper(".swiper-rooms", {
    rewind: true,
    speed: 1000,
    parallax: false,
    effect: "fade",
    modules: [EffectFade],
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-arrow-next",
      prevEl: ".swiper-arrow-prev",
    },
    on: {
      navigationPrev: (swiper) => {
        if (swiper) {
          setRoomSelected(roomsData[swiper.activeIndex].value);
          swiper.navigation.update();
        }
      },
      navigationNext: (swiper) => {
        if (swiper) {
          setRoomSelected(roomsData[swiper.activeIndex].value);
          swiper.navigation.update();
        }
      },
    },
  });
  const { router } = useRouteContext();
  const { booking } = useBookingContext();
  return (
    <div data-scroll-section className={cx(styles.section)}>
      <div className={cx(styles.titleWrapper)}>
        <div className={cx(styles.title)}>{title}</div>
        <div
          onClick={() => router.push("rooms")}
          className={cx(styles.enterOurSpacesMb)}
        >
          <Icons
            name="arrow-long-narrow-right"
            alt="next room"
            color="#F7EEDF"
            className={cx(styles.arrowIcon)}
          />
        </div>
      </div>

      <div className={cx(styles.content)}>
        <div className={cx("swiper-rooms swiper", styles.swiper)}>
          <div className={cx("swiper-wrapper")}>
            {roomsData.map((item, index) => {
              return (
                <Item
                  className={cx("swiper-slide", styles.slideItem)}
                  data={item.images}
                  key={`slide_${""}_${index}`}
                />
              );
            })}
          </div>
          <Icons
            name="arrow-long-narrow-right"
            alt="previous room"
            color="#F7EEDF"
            className={cx("swiper-arrow-prev", styles.prevArrowIcon)}
          />
          <Icons
            name="arrow-long-narrow-right"
            alt="next room"
            color="#F7EEDF"
            className={cx("swiper-arrow-next", styles.nextArrowIcon)}
          />
        </div>
        <div className={cx(styles.asideContent)}>
          <Link href={_.get(readMoreButton, "href")}>
            <Button
              type="icon"
              suffix="shape-arrow"
              className={cx(styles.enterOurSpaces)}
              label={_.get(readMoreButton, "label")}
            />
          </Link>
          <div className={cx(styles.roomOptions)}>
            {roomsData.map((room, index) => (
              <div
                key={index}
                className={cx(styles.option, {
                  [styles.selected]: roomSelected === room.value,
                })}
                onClick={() => {
                  setRoomSelected(room.value);
                  swiperRooms.slideTo(index);
                }}
              >
                {room.label}
              </div>
            ))}
          </div>
          <div className={cx(styles.detail)}>
            <div className={cx(styles.general)}>
              {roomsData
                .find((r) => r.value === roomSelected)
                ?.general?.map((g: string, index: number) => (
                  <ClipText fixedRows rows={5} key={index}>
                    {g}
                  </ClipText>
                ))}
            </div>
            <div className={cx(styles.highlight)}>
              {roomsData
                .find((r) => r.value === roomSelected)
                ?.highlight?.map((item: any, index: number) => (
                  <div key={index} className={cx(styles.item)}>
                    <Icons
                      alt={item.icon}
                      name={item.icon}
                      color="#AF915E"
                      className={cx(styles.icon)}
                    />
                    <div className={cx(styles.text)}>
                      {renderPropsComposer(
                        {
                          matcher: (item: any) => item.type === "capacity",
                          render: (item: any) => (
                            <>
                              {item.value}
                              {` `}
                              {i18n.t("SearchControl.adults")}
                            </>
                          ),
                        },
                        {
                          matcher: "default",
                          render: (item: any) => item.value,
                        }
                      )(item)}
                      {/* {item.value} */}
                    </div>
                  </div>
                ))}
            </div>
          </div>
          <div className={cx(styles.btnGroup)}>
            <Link
              href={router.toUrl("room-detail", {
                slug: roomsData.find((r) => r.value === roomSelected)?.slug,
              })}
            >
              <Button
                type="text"
                className={styles.viewRoomBtn}
                label={i18n.t("Button.viewThisRoom")}
              />
            </Link>
            <Button
              className={styles.bookRoomBtn}
              label={i18n.t("Button.bookThisRoom")}
              onClick={() => booking.open({ hotel })}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
